<ng-template #dropdownOptions>
    @if (user$ | async) {
        <a mat-menu-item [routerLink]="profileRoute" class="!text-white"
            ><mat-icon class="!text-white">account_circle</mat-icon>My
            Profile</a
        >
        <button
            (click)="logout()"
            mat-menu-item
            type="button"
            class="!text-white"
        >
            <mat-icon class="!text-white">lock_open</mat-icon>Logout
        </button>
    } @else {
        <button
            (click)="login()"
            mat-menu-item
            type="button"
            class="!text-white"
        >
            <mat-icon class="!text-white">lock</mat-icon>Login
        </button>
    }

    <button mat-menu-item type="button" (click)="tools()" class="!text-white">
        <mat-icon class="!text-white">build</mat-icon>Tools
    </button>
    <a mat-menu-item href="/" class="!text-white"
        ><mat-icon class="!text-white">shopping_cart</mat-icon>Cart</a
    >

    @if (user$ | async) {
    } @else {
        <button
            (click)="register()"
            mat-menu-item
            type="button"
            class="!text-white"
        >
            <mat-icon class="!text-white"
                ><img
                    class="h-6 w-6"
                    src="assets/svg/diagonal-top-right-arrow.svg"
                    alt="Diagonal Top Right Arrow" /></mat-icon
            >Register
        </button>
    }
</ng-template>

@if (isMobile) {
    <button
        title="menu"
        mat-button
        [matMenuTriggerFor]="menu"
        class="!min-w-min site-button"
    >
        <ng-container *ngTemplateOutlet="buttonText"></ng-container>
    </button>
    <mat-menu #menu="matMenu" class="!bg-secondary-500" [hasBackdrop]="false">
        <ng-container *ngTemplateOutlet="dropdownOptions"></ng-container>
    </mat-menu>
} @else {
    <button
        title="menu"
        mat-button
        [matMenuTriggerFor]="menu"
        class="site-button"
        (mouseenter)="mouseEnter(menuTrigger)"
        (mouseleave)="mouseLeave(menuTrigger)"
        #menuTrigger="matMenuTrigger"
    >
        <ng-container *ngTemplateOutlet="buttonText"></ng-container>
    </button>
    <mat-menu #menu="matMenu" class="!bg-secondary-500" [hasBackdrop]="false">
        <div
            (mouseenter)="mouseEnter(menuTrigger)"
            (mouseleave)="mouseLeave(menuTrigger)"
        >
            <ng-container *ngTemplateOutlet="dropdownOptions"></ng-container>
        </div>
    </mat-menu>
}

<ng-template #buttonText>
    @if (userName$ | async; as userName) {
        <span class="flex items-center space-x-2">
            <span>
                <img
                    class="h-6 w-6 rounded-full min-w-6 min-h-6 bg-tertiary-500"
                    src="assets/svg/user-profile.svg"
                    alt="User Photo"
                />
            </span>
            <span class="hidden md:block">
                @if (isMobile) {
                    {{ userName | ellipsis: 30 }}
                } @else {
                    {{ userName | ellipsis: 20 }}
                }
            </span>
        </span>
    } @else {
        <span class="!text-white">Cevo®</span>
    }
</ng-template>
